import {SYOSMain, SYOSCloseDialogWithUnreservedSeatsMode} from 'syos';
import $ from 'jquery';
import './ldialog/src/ldialog';

window.showSYOSDialog = function(houseId, typeId, pId, addtlParams) {

  let syos;
  const syosOptions = {
    siteCartModule: 'syos',
    pId: pId,
    houseId: houseId,
    typeId: typeId,
    dateSwitchTemplateString: 'dddd, MMMM D [at] h:mm a',
    highlightSamePrice: true,
    labelConfig: {
      pricetypeSelector: 'section',            // zone || section
      seatInfoDisplay: 'section',            // zone || section
      seatInfoDisplayPriceOutput: 'firstPrice' // firstPrice || priceRange
    },
    closeDialogWithUnreservedSeatsMode: SYOSCloseDialogWithUnreservedSeatsMode.RESERVE_SEATS,
    addtlParams: addtlParams,
    houseDisplayNames: {
      'the-pearlstone-theater': "The Pearlstone Theater",
      'the-narrow-head-theater': "The Head Theater",
      'the-medium-head-theater': "The Head Theater",
      'the-end-head-theater': "The Head Theater"
    }
  };


  lDialog.open({
    className: 'l-dialog-syos',
    closeOnOverlay: false
  });

  $.ajax({
    url: '/h/syos/SYOSTool',
    data: {
      perf_no: pId
    }
  }).done(function (data) {
    lDialog.open({
      className: 'l-dialog-syos',
      content: data.template,
      closeOnOverlay: false,
      beforeClose: function () {
        syos.destroy();
      },
      shouldClose: SYOSMain.shouldCloseDialog_LDialog2
    });
    syos = new SYOSMain(syosOptions);
  });

};